<template>
  <el-form
    :model="model"
    :rules="rules"
    ref="refForm"
    size="small"
    label-width="100px"
    class="demo-ruleForm"
  >
    <el-form-item label="选择视频设备">
      <el-select
        v-model="model.videoCode"
        style="width: 100%"
        @change="devChange"
        placeholder="请选择视频设备"
      >
        <el-option
          v-for="item in devOption"
          :key="item.id"
          :label="item.name"
          :value="item.tag"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="修改设备名称">
      <el-input
        class="input_box text_center_input"
        placeholder="请输入设备名称"
        v-model="model.monitorName"
      >
      </el-input>
    </el-form-item>
    <el-form-item label="设备IP">
      <el-input
        class="input_box text_center_input"
        placeholder="请输入设备IP"
        v-model="model.monitorIp"
      >
      </el-input>
    </el-form-item>
  </el-form>
</template>

<script>
import { deepClone, mapTo } from "@/libs/util";
export default {
  props: {
    devId: {
      type: String,
      default: "",
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      devOption: [],
      model: {
        id: "",
        videoCode: "",
        monitorName: "",
        monitorIp: "",
      },
      rules: {
        monitorName: [
          { required: true, message: "请输入设备名称", trigger: "blur" },
        ],
        monitorIp: [
          { required: true, message: "请输入设备IP", trigger: "blur" },
        ],
        videoCode: [
          { required: true, message: "请选择视频设备", trigger: "blur" },
        ],
      },
    };
  },
  created() {
    this.getDevList();
    if (this.row) {
      mapTo(this.row, this.model);
    }
    this.model.id = this.devId;
  },
  submit(dialog, callback) {
    this.$refs.refForm.validate(async (valid) => {
      if (valid) {
        const res = await this.$api.EditJKBLVideoData(this.model);
        if (res) {
          callback();
          dialog.okLoading = false;
          dialog.close();
          setTimeout(() => {
            this.$msg.success("设置成功");
          }, 500);
        }
      }
    });
  },
  methods: {
    devChange(val) {
      let devName = this.devOption.find((item) => item.tag == val)?.name || "";
      this.model.monitorName = devName;
    },
    async getDevList() {
      const res = await this.$api.IotDevEnterpriseDropList({
        devTypeId: "1004",
      });
      this.devOption = res || [];
    },
  },
};
</script>

<style lang="scss" scoped>
.demo-ruleForm {
  margin-top: 20px;
}
</style>